const InningHalf = {
    Top:            { key: 1,       name: 'Top',              short: '▲'},
    Bottom:         { key: 0,       name: 'Bottom',           short: '▼'},
    Unidentified:   { key: 'UI',    name: 'Unidentified',     short: '-'},
};

export default InningHalf;